import {createStore} from "effector";

export const $certsList = createStore({count: 0, data: []})

export const $selectedCert = createStore({})

export const $selectedCertSupplier = createStore({})